export * from './post-sync-azure-active-directory.component';
export * from './post-sync-azure-active-directory.component.module';